<template>
    <nav class="pagination-nav" aria-label="Pagination" v-if="pagination.total > 0">
      <div class="pagination-info">
        Showing <strong>{{ pagination.from }}</strong>–<strong>{{ pagination.to }}</strong>
        of <strong>{{ pagination.total }}</strong>
      </div>
  
      <div class="pagination-controls">
  
        <!-- Previous -->
        <button
          class="page-btn"
          :class="{ 'page-btn--disabled': !pagination.prevPageUrl }"
          :disabled="!pagination.prevPageUrl"
          @click.prevent="$emit('prev')"
          aria-label="Previous page"
        >
          <font-awesome-icon icon="chevron-left" class="page-btn-icon" />
          <span>Previous</span>
        </button>
  
        <!-- Current page indicator -->
        <span class="page-indicator" aria-current="page">
          {{ pagination.currentPage }} / {{ pagination.lastPage }}
        </span>
  
        <!-- Next -->
        <button
          class="page-btn"
          :class="{ 'page-btn--disabled': !pagination.nextPageUrl }"
          :disabled="!pagination.nextPageUrl"
          @click.prevent="$emit('next')"
          aria-label="Next page"
        >
          <span>Next</span>
          <font-awesome-icon icon="chevron-right" class="page-btn-icon" />
        </button>
  
      </div>
    </nav>
  </template>
  
  <script>
  export default {
    name: 'Pagination',
    props: {
      pagination: {
        type: Object,
        required: true,
      },
    },
    emits: ['prev', 'next'],
  };
  </script>
  
  <style scoped>
  .pagination-nav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
    padding: 16px 0;
    flex-wrap: wrap;
  }
  
  .pagination-info {
    font-size: 13px;
    color: #7a90b0;
  }
  .pagination-info strong { color: #1a2b45; }
  
  .pagination-controls {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  
  .page-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border: 1px solid #dde5f0;
    border-radius: 8px;
    background: #fff;
    color: #1a2b45;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all .15s;
    white-space: nowrap;
    font-family: inherit;
  }
  .page-btn:hover:not(:disabled):not(.page-btn--disabled) {
    background: #004AAD;
    color: #fff;
    border-color: #004AAD;
  }
  .page-btn--disabled,
  .page-btn:disabled {
    opacity: .45;
    cursor: not-allowed;
    pointer-events: none;
  }
  
  .page-btn-icon { font-size: 11px; }
  
  .page-indicator {
    padding: 7px 14px;
    border: 1px solid #e4eaf2;
    border-radius: 8px;
    background: #f8fafc;
    font-size: 13px;
    font-weight: 600;
    color: #1a2b45;
    white-space: nowrap;
  }
  </style>